import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Support from "./pages/Support";
import PremiumBitcoinMistakes from "./pages/PremiumBitcoinMistakes";
import Privacy from "./pages/Privacy";
import Disclaimer from "./pages/Disclaimer";
import Terms from "./pages/Terms";
import FAQ from "./pages/FAQ";
import Free from "./pages/Free";
import Start from "./pages/Start";
import TenRules from "./pages/TenRules";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />

          <Route
            path="/p/bitcoin-mistakes-2017-2025"
            element={<PremiumBitcoinMistakes />}
          />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/free" element={<Free />} />
          <Route path="/start" element={<Start />} />
          <Route path="/10rules" element={<TenRules />} />
        </Routes>
      </BrowserRouter>

      <Toaster position="top-center" />
    </div>
  );
}

export default App;
